import React, { Component } from 'react';
import Message from './message';
import { differenceInHours } from 'date-fns';

export default class MessageList extends Component {

  componentDidUpdate() {
    if (this.props.scroll) {
      this.scrollToBottom();
      this.props.scrollDone();
    }
  }

  getMessages = (conversation) => {
    let messages = [];
    if (conversation && conversation.history) {
      conversation.history.forEach((message, i) => {
        messages.push({
          id: i,
          author: message.sender,
          message: message.text,
          timestamp: message.at
        })
      })
    }
    return messages;
  }

  scrollToBottom() {
    this.messagesEnd.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }

  renderMessages() {
    let i = 0;
    let messageList = this.getMessages(this.props.conversation);
    let messageCount = messageList.length;
    let messages = [];

    while (i < messageCount) {
      let previous = messageList[i - 1];
      let current = messageList[i];
      let next = messageList[i + 1];
      let isMine = current.author === this.props.userId;
      let prevBySameAuthor = false;
      let nextBySameAuthor = false;
      let startsSequence = true;
      let endsSequence = true;
      let showTimestamp = true;

      if (previous) {
        prevBySameAuthor = previous.author === current.author;
        const diffHours = differenceInHours(new Date(current.timestamp), new Date(previous.timestamp));
        if (prevBySameAuthor && diffHours < 1) {
          startsSequence = false;
        }

        if (diffHours < 1) {
          showTimestamp = false;
        }
      }

      if (next) {
        const diffHoursNext = differenceInHours(new Date(next.timestamp), new Date(current.timestamp));
        nextBySameAuthor = next.author === current.author;

        if (nextBySameAuthor && diffHoursNext < 1) {
          endsSequence = false;
        }
      }

      messages.push(
        <Message
          key={i}
          isMine={isMine}
          startsSequence={startsSequence}
          endsSequence={endsSequence}
          showTimestamp={showTimestamp}
          data={current}
        />
      );

      // Proceed to the next message.
      i += 1;
    }
    return messages;
  }

  render() {
    return (
      <div className="message-list">
        <div className="message-list-container">
          {this.renderMessages()}
          <div className="scrollBottom" ref={(node) => { this.messagesEnd = node; }}></div>
        </div>
      </div>
    );
  }
}